import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useTranslation } from 'react-i18next';

const RTE = ({ company, onContentChange, rteContent }) => {
  const [t] = useTranslation("companies")
  const [text, setText] = useState('');
  const [editorContent, setEditorContent] = useState(''); // Nuevo estado para el contenido del editor

  useEffect(() => {
    const initialData = rteContent ? rteContent : `${t("rte.welcomeText")}`;
    setText(initialData);
    setEditorContent(initialData);

  }, [company, rteContent]);

  function processHtml(inputHtml) {
    // Crear un elemento del DOM en memoria para manipular el HTML
    const template = document.createElement('template');
    template.innerHTML = inputHtml;


    const classesToStyles = {
      'ql-align-center': 'text-align: center',
      'ql-align-right': 'text-align: right',
      'ql-align-justify': 'text-align: justify',
    };


    Object.keys(classesToStyles).forEach(className => {
      // Encuentra todos los elementos con la clase
      const elements = template.content.querySelectorAll(`.${className}`);

      elements.forEach(el => {
        el.removeAttribute('class');
        el.style = classesToStyles[className];
      });
    });

    // Procesar los enlaces
    const links = template.content.querySelectorAll('a');
    links.forEach(link => {
      let href = link.getAttribute('href');
      // Si el href no empieza con "http://" o "https://", añadir "https://"
      if (href && !href.startsWith('http://') && !href.startsWith('https://')) {
        link.setAttribute('href', 'https://' + href);
      }
    });
    return template.innerHTML.replace(/"/g, "'");
  }

  const handleChange = (newValue) => {
    var editorContentFormatted = processHtml(newValue)
    if (editorContentFormatted !== rteContent) {
      if (onContentChange) {
        onContentChange(editorContentFormatted);
      }
      setEditorContent(newValue);
    }

  }

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ 'direction': 'rtl' }],
      [{ 'header': ['1', '2', false] }], // header se usa para los estilos de título
      ['link'],
      ['clean'],
    ]
  };

  function addCustomStyles() {
    const style = document.createElement('style');
    style.innerHTML = `
      .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before {
        content:  '${t("rte.title1")}'!important;
      }
      .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before {
        content: '${t("rte.title2")}' !important;
      }
      .ql-snow .ql-picker.ql-header .ql-picker-label::before {
        content:  '${t("rte.text")}' !important;
      }
      .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '${t("rte.title1")}' !important;
      }
      .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content:  '${t("rte.title2")}' !important;
      }
      .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content:  '${t("rte.text")}' !important;
      }
    `;
    document.head.appendChild(style);
  }


  useEffect(() => {
    addCustomStyles();

  }, []);

  return (
    <div className="mt-3 rounded-border-px custom-shadow">

      <ReactQuill
        value={editorContent}
        onChange={handleChange}
        modules={modules}
      />

    </div>
  );
}

export default RTE;